import { MOCK_SUPPORTER_MIXED_COMMITMENTS } from './mocks/supporters.ts';

export const QUERY_KEYS = {
  dataPrimerReadOnly: 'dataPrimer',
  supporterPaymentSettings: 'supporterPaymentSettings',
  supporterDataStatus: 'supporterDataStatus',
  supporterPaymentMethods: 'supporterPaymentMethods',
  supporterCommitments: 'supporterCommitments',
  supporterGivingTotals: 'supporterGivingTotals',
  supporterAddress: 'supporterAddress',
  supporterGivingHistory: 'supporterGivingHistory',
  supporterPledges: 'supporterPledges',
  supporterTaxReceipts: 'supporterTaxReceipts',
  supporterDetails: 'supporterDetails',
};

export const MUTATION_KEYS = {
  makeAPaymentAdd: 'makeAPaymentAdd',
  paymentMethodRemove: 'paymentMethodRemove',
  commitmentPaymentPlanUpdate: 'commitmentPaymentPlanUpdate',
  addressUpdate: 'addressUpdate',
};

export const MOCK_SUPPORTER =
  process.env.NEXT_PUBLIC_USE_MOCK_SUPPORTER &&
  process.env.NEXT_PUBLIC_USE_MOCK_SUPPORTER !== 'false'
    ? MOCK_SUPPORTER_MIXED_COMMITMENTS
    : null;
